import { Grid } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import placeholderImage from "../../../assets/placeholder.jpg";

export default function UpgradeBalanceDetails({ balance }) {
  const fontSize = { fontSize: "16px" };
  const fontWeight = { fontWeight: "500" };
  return (
    <div>
      <Grid container spacing={2} justifyContent="center">
        {balance?.transaction_for !== "Refund Balance" && (
          <Grid item sx={6}>
            <div style={{ margin: "30px 0px 20px 0px" }}>
              <a href={balance?.media} target="_blank" rel="noreferrer">
                <img
                  src={balance?.media || placeholderImage}
                  alt=""
                  style={{ width: "300px", height: "200px" }}
                />
              </a>
              <p>Payment Receipt</p>
            </div>
          </Grid>
        )}
        <Grid
          item
          sx={balance?.transaction_for === "Refund Balance" ? 12 : 6}
          width={"50%"}
        >
          <div
            style={{
              marginTop: "20px",
              borderLeft: `${
                balance?.transaction_for !== "Refund Balance"
                  ? "1px solid lightgray"
                  : ""
              } `,
              paddingLeft: "15px",
            }}
          >
            <div className="flexbox">
              <h6 style={fontSize}>Payment For</h6>
              <h6 style={fontWeight}>{balance?.transaction_for}</h6>
            </div>
            {balance?.order_number && (
              <div className="flexbox">
                <h6 style={fontSize}>Order Number</h6>
                <h6 style={fontWeight}>{balance?.order_number}</h6>
              </div>
            )}
            <div className="flexbox">
              <h6 style={fontSize}>Payment Type</h6>
              <h6 style={fontWeight}>{balance?.transaction_type}</h6>
            </div>
            <div className="flexbox">
              <h6 style={fontSize}>Payment Method</h6>
              <h6 style={fontWeight}>{balance?.payment_method}</h6>
            </div>
            {balance?.initial_deposit_amount && (
              <div className="flexbox">
                <h6 style={fontSize}>Accepted Deposit Amount</h6>
                <h6 style={fontWeight}>€{balance?.amount}</h6>
              </div>
            )}
            <div className="flexbox">
              <h6 style={fontSize}>
                {balance?.initial_deposit_amount
                  ? "Initial Deposit Amount"
                  : "Amount"}
              </h6>
              <h6 style={fontWeight}>
                €
                {balance?.initial_deposit_amount
                  ? balance?.initial_deposit_amount?.toFixed(2)
                  : balance?.amount
                  ? balance?.amount?.toFixed(2)
                  : balance?.verified_amount
                  ? balance?.verified_amount?.toFixed(2)
                  : balance?.refund_amount}
              </h6>
            </div>
            <div className="flexbox">
              <h6 style={fontSize}>Payment Date</h6>
              <h6 style={fontWeight}>
                {dayjs(balance?.createdAt).format("YYYY-MM-DD")}
              </h6>
            </div>
            <div className="flexbox">
              <h6 style={{...fontSize,lineHeight:1, textAlign:"left", width:"200px"}}>
                {balance?.transaction_for === "Refund Balance"
                  ? "Refund reason"
                  : "Notes"}
              </h6>
              <h6 style={{...fontWeight, lineHeight:1.5, textAlign:"left"}}>{balance?.notes || "Not available"}</h6>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
